// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class LocationCityModel {
    static getAttributeTypeMap() {
        return LocationCityModel.attributeTypeMap;
    }
}
LocationCityModel.discriminator = undefined;
LocationCityModel.additionalProperties = false;
LocationCityModel.attributeTypeMap = [
    {
        "name": "cityName",
        "baseName": "cityName",
        "type": "string"
    },
    {
        "name": "stateName",
        "baseName": "stateName",
        "type": "string"
    },
    {
        "name": "stateAbbr",
        "baseName": "stateAbbr",
        "type": "string"
    },
    {
        "name": "cityType",
        "baseName": "cityType",
        "type": "string"
    },
    {
        "name": "countyName",
        "baseName": "countyName",
        "type": "string"
    },
];
//# sourceMappingURL=locationCityModel.js.map